import styled from 'styled-components';

import { ICard } from './Card';

export const ItemCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.gray950};
  border-radius: 8px;
  padding: 2px;
  margin: 0 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04), 0 4px 8px rgba(0, 0, 0, 0.03);
`;

export const ItemHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const ItemTitle = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.gray0};
`;

export const SwitchContainer = styled.div`
  display: flex;
  gap: 12px;
`;

export const SwitchBox = styled.button<ICard.ISwitch>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: ${({ buttonType }) => (buttonType === 'check' ? '20px' : '32px')};
  padding: 0;

  border: ${({ theme, isChecked }) => (!isChecked ? `${theme.colors.gray100} 2px solid` : 'none')};
  background-color: ${({ theme, isChecked, buttonType }) =>
    isChecked
      ? buttonType === 'check'
        ? theme.colors.primaryGreen500
        : theme.colors.red500
      : 'transparent'};

  :before {
    color: ${({ theme, isChecked, buttonType }) =>
      isChecked
        ? buttonType === 'check'
          ? theme.colors.gray0
          : theme.colors.gray950
        : theme.colors.gray0};
  }
`;

export const QuestionContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 12px 0 12px;
  margin-top: 2px;
  background-color: ${({ theme }) => theme.colors.gray800};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  gap: 24px;
`;

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DefContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 19px;
  gap: 8px;
`;

export const AddImage = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  font-size: 32px;
  border: 2px dashed ${({ theme }) => theme.colors.primaryGreen500};

  flex: 1;
  border-radius: 4px;
  min-width: 26vw;

  :before {
    background: -webkit-linear-gradient(rgba(64, 255, 175, 1), rgba(0, 184, 107, 1));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const ImageWrapper = styled.div`
  min-width: 26vw;
  max-width: 27vw;
  height: 20vw;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.gray900};
  flex: 1;

  img {
    border-radius: 8px;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  left: 4px;
  top: 4px;
  width: 24px;
  height: 24px;
  padding: 4px;
  background: rgba(28, 38, 49, 0.56);
  border-radius: 4px;
  border: none;
  font-size: 16px;
`;
